exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".d6Uhu {\n  padding: 20px;\n  overflow: auto;\n}\n.d6Uhu ._2Vxi5 {\n  white-space: pre;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "d6Uhu",
	"pre": "_2Vxi5"
};